import classnames from 'classnames';
import filtersMap from 'components/FiltersModal/filtersMap';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { FILTER_BUTTON } from '../constants';

import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { useFeatureFlags } from '../../../hooks/LaunchDarkly/useFeatureFlags';

const FilterButton = ({ filter, openClick, searchFilters }) => {
	const { globalization, filterOpen } = useContext(CruiseSearchContext);
	const { showMyOffers } = useFeatureFlags();

	const { filtersDictionary } = globalization?.dictionaries || {};

	const { key, ButtonComponent } = filter;
	const selected = key === filterOpen;
	const filterClasses = classnames({
		selected,
		[`filter-dropdown-${key}`]: true,
		[FILTER_BUTTON]: true,
	});
	const labelKey = filtersMap[key]?.labelKey || '';
	const label = filtersDictionary[labelKey] || '';
	if (filter.key === filtersMap.qualifiers.key && !showMyOffers) return;
	return (
		<ButtonComponent
			key={key}
			openFilter={(e) => {
				openClick(e, key);
			}}
			className={filterClasses}
			label={label}
			searchFilters={searchFilters}
			dataTestId={filter.dataTestId}
		/>
	);
};

FilterButton.propTypes = {
	filter: PropTypes.object,
	openClick: PropTypes.func,
};

export default FilterButton;
